import { Font } from '../types/default-types'

const font: Font = {
  primary: 'Montserrat',
  secondary: '',
  tertiary: '',
  other: '',
}

export default font
